import { Skeleton } from "@offstreetparking/design-system/feedback";

export const ContactSkeleton = () => {
	return (
		<div className="flex flex-col gap-4 pb-24 md:pb-0">
			{/* "Need Help?" title */}
			<Skeleton height={20} width={100} />

			{/* Support text */}
			<div className="space-y-2">
				<Skeleton height={16} width={280} />

				{/* Email line */}
				<div className="flex items-end gap-1">
					<Skeleton height={16} width={40} />
					<Skeleton height={16} width={180} />
				</div>

				{/* Phone line */}
				<div className="flex items-end gap-1">
					<Skeleton height={16} width={45} />
					<Skeleton height={16} width={120} />
				</div>
			</div>

			{/* Technical support section */}
			<div className="space-y-2">
				<Skeleton height={16} width={260} />

				<div className="flex items-end gap-1">
					<Skeleton height={16} width={40} />
					<Skeleton height={16} width={160} />
				</div>
			</div>

			{/* Terms of service link */}
			<div className="xl:hidden">
				<Skeleton height={16} width={120} />
			</div>
		</div>
	);
};
